import React, { useState } from 'react';
import { Container } from '@mui/material';
import Home from './Home';
import ListeBDC from './ListeBDC';
import AdresseFacturation from './AdresseFacturation';
import BonDeCommande from '../models/BonDeCommande';

const FacturationScreen = () => {
  const [bonDeCommandeSelectionne, setBonDeCommandeSelectionne] = useState<BonDeCommande | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshBonsDeCommande = () => {
    setRefreshKey((oldKey) => oldKey + 1);
  };

  return (
    <>
      <Home />
      <Container>
        <h2>Facturation</h2>

        {/* Le tableau ListeBDC sur toute la largeur */} 
        <ListeBDC
          setBonDeCommandeSelectionne={setBonDeCommandeSelectionne}
          refreshKey={refreshKey}
        />

        {/* Quand un bon de commande est sélectionné, on affiche l'adresse de facturation en dessous */}
        {bonDeCommandeSelectionne && (
          <AdresseFacturation
            bonDeCommande={bonDeCommandeSelectionne}
            onRefresh={refreshBonsDeCommande}
          />
        )}
      </Container>
    </>
  );
};

export default FacturationScreen;
